module.exports = __webpack_public_path__ + "img/cry_ios_802.png";